module.exports = __webpack_public_path__ + "img/empty-prop-blue.35ca6a17.svg";